module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/color-intercom-828215ca0d3707b88db5ff2f90c67fa1.svg";